import type { SVGProps } from "react";
export interface AzureAdLogoGreyIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function AzureAdLogoGreyIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: AzureAdLogoGreyIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M11.912 2c.021 0 .043.027.074.074.034.05 2.262 2.724 4.961 5.947 2.703 3.228 4.908 5.884 4.898 5.9-.02.027-2.166 1.788-4.781 3.917a3342 3342 0 0 0-4.957 4.038c-.174.143-.185.148-.249.085-.045-.044-2.278-1.87-4.971-4.065-2.698-2.2-4.898-4.013-4.887-4.04.024-.042 2.234-2.68 4.935-5.882 2.708-3.212 4.924-5.868 4.934-5.91.01-.043.027-.064.043-.064m.153 4.362c-.471 0-.715.08-1.043.34-.605.476-.78 1.272-.435 1.987l.17.355-.567.541c-.822.78-2.524 2.332-2.736 2.491-.18.138-.186.137-.472.042-.524-.175-1.07-.037-1.478.371-.302.302-.398.546-.398 1.018 0 .487.106.726.472 1.065.509.472 1.155.514 1.776.122.19-.121.296-.159.36-.122.048.027.742.403 1.537.832.795.43 1.5.822 1.559.865.106.08.105.09-.059.43-.212.455-.228 1.027-.037 1.393.153.297.524.615.832.726.302.112.52.11.88.01.355-.106.763-.45.928-.795.148-.312.164-.81.032-1.129-.138-.323-.117-.402.148-.62.435-.35 2.39-1.69 2.518-1.722.074-.021.254.042.487.17.313.169.424.2.72.2.425 0 .658-.09.976-.375.45-.408.636-1.087.424-1.59-.328-.785-1.16-1.135-1.95-.822-.17.063-.35.117-.403.117-.054-.001-.212-.133-.355-.297-.81-.943-2.341-2.793-2.432-2.947-.107-.175-.107-.181.004-.467.414-1.034-.355-2.189-1.458-2.189m.843 3.122c.106 0 .563.498 1.803 1.966l1.155 1.373-.015.446a4 4 0 0 1-.043.561c-.027.106-.45.393-2.72 1.818-.418.266-.779.482-.79.477-.1 0-.121-.457-.137-3.158l-.015-3.017.35-.232c.19-.127.374-.233.412-.234m-1.642.005c.016.001.106.107.2.234l.17.233v3.02c0 2.448-.015 3.037-.084 3.096-.059.048-.223-.021-.695-.297-1.717-.99-2.861-1.722-2.867-1.844 0-.054 0-.212.005-.355a1.8 1.8 0 0 0-.106-.567 4 4 0 0 1-.117-.345c.008-.07 3.425-3.175 3.494-3.175"
      />
    </svg>
  );
}
